import { ref } from 'vue'
import type { Plan } from '@/lib/types'
import regions from "@/data/regions.json";

export function usePlans(regionCode: string) {
    const plans = ref<Plan[]>([])
    const regionName = ref<string>('')
    const loading = ref<boolean>(true)

    const fetchPlans = async () => {
        try {
            const response = await fetch(
                `${import.meta.env.VITE_API_BASE_URL}/plans/${regionCode}`
            )
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

            plans.value = await response.json()
            const region = regions.find(x => x.code === regionCode);
            regionName.value = region?.name || regionCode;
        } catch (error) {
            console.error('Error fetching plans:', error)
            const region = regions.find(x => x.code === regionCode);
            regionName.value = region?.name || regionCode;
        } finally {
            loading.value = false
        }
    }

    return { plans, regionName, loading, fetchPlans }
}

